export default "__VITE_ASSET__e41d91c3__"